export default {"src":"/_next/static/image/public/images/ic_package.4a04c7850aebb2d35db31255cdfe5689.svg","height":31,"width":29};